export const TARGETS = {
  UPLOAD_IMAGE: 'uploadImage',
  DOWNLOAD_CSV: 'downloadCsv',
  IMAGE_URL: 'imageUrl'
};
